import React from 'react'
import {IconProps} from 'types/IconProps'

const Edit = ({size = 24}: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <path
        d="M12 18.317h7M15.5 5.483a1.649 1.649 0 012.76.74c.153.57-.01 1.177-.427 1.594l-9.722 9.722L5 18.317l.778-3.111L15.5 5.483z"
        stroke="#6A7886"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.8}
      />
    </g>
  </svg>
)

export default Edit
